module.exports = __webpack_public_path__ + "static/media/step-7.0f7388fd.svg";